module.exports = __webpack_public_path__ + "img/150.5a3da6a7.jpg";